module.exports = __webpack_public_path__ + "static/media/incircle_logo.d24fb35f.svg";